interface Props {
  brand?: string
  sku: string
  bladderLeakageLevel?: string
}

export const useCustomGTM = () => {
  const triggerQuizResult = ({ brand, sku, bladderLeakageLevel }: Props) => {
    // @ts-expect-error
    const dataLayer = window.dataLayer

    if (!dataLayer) {
      return
    }

    dataLayer.push({
      event: 'QuizCompletion',
      data: {
        brand,
        sku,
        bladderLeakageLevel
      }
    })
  }

  return {
    triggerQuizResult
  }
}
